import { defineStore } from 'pinia'
import {
    getTokenCookie,
    setTokenCookie,
    removeTokenCookie,
    getUsersCookie,
    setUsersCookie,
    removeUsersCookie,
    getDictsCookie,
    removeDictsCookie,
    getAppsCookie,
    setAppsCookie,
    removeAppsCookie,
} from '@/utils/cookie'

// 用户相关状态 持久化存储cookie
export const useUserStore = defineStore('user', {
    state: () => ({
        token: getTokenCookie() ?? null,
        users: getUsersCookie() ? JSON.parse(getUsersCookie()) : {},
        dicts: getDictsCookie() ? (JSON.parse(getDictsCookie())).sfl : {},
        apps: getAppsCookie() ? JSON.parse(getAppsCookie()) : {},
    }),
    getters: {
        getToken() {
            return this.token
        },
        getUsers() {
            return this.users
        },
        getDicts() {
            return this.dicts
        },
        getApps() {
            return this.apps
        },
    },
    actions: {
        setToken(val) {
            this.token = val
            val ? setTokenCookie(val) : removeTokenCookie()
        },
        setUsers(val) {
            this.users = val
            val ? setUsersCookie(JSON.stringify(val)) : removeUsersCookie()
        },
        setDicts(val) {
            this.dicts = val
            if (!val) {
                removeDictsCookie()
            }
        },
        setApps(val) {
            this.apps = val
            val ? setAppsCookie(JSON.stringify(val)) : removeAppsCookie()
        },
    },
    persist: {
        enabled: false, // 是否开启本地sessionStorage数据缓存
    },
})
